import type { State } from './types';

/**
 * Context selectors for navigation and portal context.
 * These selectors are designed to avoid cyclic dependencies.
 */

export const isSinglePortalContext = (state: State): boolean =>
    state.ui?.context.portalId !== undefined &&
    state.ui?.context.portalId !== null &&
    !isNaN(state.ui?.context.portalId || NaN);

export const getPortalId = (state: State): number | undefined => {
    if (!isSinglePortalContext(state)) {
        return undefined;
    }
    return state.ui?.context.portalId;
};

export const getRoutename = (state: State): string | undefined => {
    return state.ui?.context.routeName;
};
